import useArticleMetadataValues from "../../../hooks/useArticleMetadataValues";

import getVersionFields from "../utils/getVersionFields";

const keys = ["announcementDate", "releaseDate", "takedownDate", "countries", "prices", "deliveryTypes", "subChannels"];

export default function useArticleVersionsChannelFields({ showSubChannels, hasSubChannels, before, after }) {
	const getValues = useArticleMetadataValues();

	const channelKeys = keys.filter((key) => showSubChannels || key !== "subChannels");

	return getVersionFields(getValues, channelKeys, before, after).map((field) =>
		field.key === "subChannels" && !hasSubChannels
			? { ...field, value: "–", highlighted: false, removed: false }
			: field,
	);
}
